export interface InteriorPage {
  src: string
  alt: string
}

export const interiorPages: InteriorPage[] = [
  {
    src: 'https://cdn.magicpatterns.com/uploads/mL7dfFUhdPqe8MEdCfiecX/01_The_Art_of_Stillness-07.png',
    alt: 'Real Yoga Teacher System class page: YTS-081 The Art of Stillness, 75 minutes, all levels',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/1Eho6tGw59516a2VUcKio7/02_Parasympathetic_Reset-10.png',
    alt: 'Real Yoga Teacher System class page: YTS-084 The Parasympathetic Reset, 60 minutes, all levels',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/7qXcmbonngKu85X8Mgs2m8/03_Desk_Recovery-07.png',
    alt: 'Real Yoga Teacher System class page: YTS-101 The Desk Recovery chair yoga class',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/mEZm32gt8PSjGvNEYuf1HU/04_Early_Bird-09.png',
    alt: 'Real Yoga Teacher System class page: YTS-103 The Early Bird 30-minute energizer',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/dvAAK3oCNQEmkYceD2X282/05_Candlelight-19.png',
    alt: 'Real Yoga Teacher System class page: YTS-113 The Candlelight evening class, 75 minutes',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/7urnCCzQgAheLnPUwT49NR/06_Full_Spectrum_Master_Class-26.png',
    alt: 'Real Yoga Teacher System class page: YTS-120 The Full Spectrum Master Class, 90 minutes',
  },
]
